module.exports = __webpack_public_path__ + "img/Google.f296d277.png";